import axios from '../../plugins/axios';

export default {
	async validate(value, [fieldName]) {

		try {
			await axios.post('account/validation', { [fieldName]: value });
		} catch({response}) {
			return {
				valid: false,
				data: { message: response.data.errors[fieldName][0]}
			}
		}

		return { valid: true }
	},
	getMessage(field, params, data) {
		return data.message;
	}
};
